export const window = global;

export const { console, document, fetch, FormData, getComputedStyle } = global;
